import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import cookies from 'js-cookie'

Vue.use(Vuex)

var store = new Vuex.Store({

	modules: {},

	state: {
		initiated: false,
		key: ''
	},

	getters: {

		initiated: function(state) {

			return state.initiated

		},

		key: function(state) {

			return state.key

		}

	},

	mutations: {

		initiated: function(state, value) {

			state.initiated = value

		},

		key: function(state, value) {

			state.key = value

			if (value) {
				
				cookies.set(process.env.VUE_APP_COOKIE, value, {
					expires: 365
				})

			} else {

				cookies.remove(process.env.VUE_APP_COOKIE)

			}

			axios.defaults.headers.common['Authorization'] = value

		}

	},

	actions: {

		init: async function(context) {

			if (!context.getters['initiated']) {

				if (cookies.get(process.env.VUE_APP_COOKIE) !== undefined) context.commit('key', cookies.get(process.env.VUE_APP_COOKIE))

				context.commit('initiated', true)
					
			}

		}

	}

})

export default store